import { Component } from 'react';

export default class AppComponent extends Component {

  modulesGroupLabels = () => {
    return {
      'all' : 'ALL STAFF',
      'field' : 'MANDATORY TRAINING FOR FIELD STAFF ONLY',
      'other' : 'TEAM SPECIFIC',
      'emergency' : 'EMERGENCY RESPONSE - PROJECT',
    }
  }
  
  hideLoadingMessage(){
    var message = document.getElementById('loading-message')
    message.style.display = 'none';
    this.setState({
      loading: false
    })
  }

  showLoadingMessage(){
    var message = document.getElementById('loading-message')
    message.style.display = 'inline-block';
    this.setState({
      loading: true
    })
  }

  isInObjectArray = (objectArray, value) => {
    return objectArray.some((obj) => {
      return obj.value === value
    });
  }

  getObject = (objectArray, value, attr) => {
    return objectArray.find(function(obj, index, arr){
      return obj[attr] === value
    })
  }

  getModule = (modules, name, refresher_period, category) => {
    return modules.find(function(obj, index, arr){
      return obj.name === name && obj.refresher_period === refresher_period && obj.category === category
    })
  }

  autoPositionElement = (evt, element) => {
    var body = document.body, html = document.documentElement;

    var width = Math.max( body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth );
    var height = Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight );

    let xOffset = Math.max(html.scrollLeft, body.scrollLeft);
    let yOffset = Math.max(html.scrollTop, body.scrollTop);

    var elementOffsetWidth = evt.type === 'click' ? element.offsetWidth : 0
    var elementOffsetHeight = evt.type === 'click' ? element.offsetHeight : 0

    var left, top
    if (evt.clientX + xOffset + elementOffsetWidth > width) {
      left = evt.clientX + xOffset - elementOffsetWidth
    } else {
      left = evt.clientX + xOffset
    }

    if (evt.clientY + yOffset + elementOffsetHeight > height) {
      top = evt.clientY + yOffset - elementOffsetHeight
    } else {
      top = evt.clientY + yOffset
    }

    element.style.left = `${left}px`
    element.style.top = `${top}px`
    element.style.visibility = 'visible'   
    element.addEventListener('mouseleave', ()=>{ element.style.visibility = 'hidden'; } );
  }

  getTagId = (tag_name, allTags=this.state.allTags) => {
    var found_tag = allTags.find((tag) => { return tag.value === tag_name });
    return found_tag.id
  }

  render() {
    return
  }
}



// WEBPACK FOOTER //
// ./src/views/components/app_component.js